"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useCodeMirror_1 = __importDefault(require("./useCodeMirror"));
exports.default = useCodeMirror_1.default;
